// Footer newsletter collapsible fix
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.querySelector('.footer__item--newsletter .collapsible-trigger-btn');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var content = this.closest('.footer__item-padding').querySelector('.collapsible-content');
    if (!content) return;
    var isOpen = content.classList.contains('is-active');
    content.classList.toggle('is-active', !isOpen);
    this.setAttribute('aria-expanded', String(!isOpen));
  });
});

// ===== 两级颜色筛选器 =====
var _gPopup = document.createElement('div');
_gPopup.style.cssText = 'display:none;position:fixed;background:#fff;border:1px solid #e0e0e0;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,0.15);padding:14px;z-index:2147483647;width:420px;max-height:60vh;overflow-y:auto;overflow-x:hidden;';
document.body.appendChild(_gPopup);

var _activeBtn = null;

function _closePopup() {
  _gPopup.style.display = 'none';
  _activeBtn = null;
  document.querySelectorAll('.color-group-item.is-open').forEach(function(el) {
    el.classList.remove('is-open');
  });
  if (window._cpScroll) {
    window.removeEventListener('scroll', window._cpScroll, true);
    window._cpScroll = null;
  }
}

function _positionPopup(btn) {
  var rect = btn.getBoundingClientRect();
  var left = rect.left;
  if (left + 420 > window.innerWidth) left = window.innerWidth - 428;
  if (left < 4) left = 4;
  _gPopup.style.top = (rect.bottom + 6) + 'px';
  _gPopup.style.left = left + 'px';
}

document.addEventListener('click', function(e) {
  var btn = e.target.closest('.color-group-btn');
  if (btn) {
    e.stopPropagation();
    var item = btn.closest('.color-group-item');
    var isOpen = item.classList.contains('is-open');
    _closePopup();
    if (!isOpen) {
      var src = item.querySelector('.color-subgroup-popup');
      if (!src) return;
      _gPopup.innerHTML = src.innerHTML;
      _gPopup.style.display = 'block';
      item.classList.add('is-open');
      _activeBtn = btn;
      _positionPopup(btn);
      window._cpScroll = function() { if (_activeBtn) _positionPopup(_activeBtn); };
      window.addEventListener('scroll', window._cpScroll, true);
    }
    return;
  }
  if (!_gPopup.contains(e.target)) {
    _closePopup();
  }
});

_gPopup.addEventListener('click', function(e) {
  var item = e.target.closest('.color-sub-item');
  if (!item) return;
  var checkbox = item.querySelector('.tag__input');
  if (!checkbox) return;
  var container = document.querySelector('#color-filter-metaobject');
  var base = (container && container.dataset.baseCollection) || window.location.pathname;
  var url = new URL(base, window.location.origin);
  url.searchParams.set(checkbox.name, checkbox.value);
  window.location.href = url.toString();
});
